const DEFAULT_CONTROL_PLANE_DOMAINS = [
  'admin.imobiliaria.f2data.com.br',
];

const configuredControlPlaneDomains = () => {
  const configured = process.env.REACT_APP_CONTROL_PLANE_DOMAINS;
  if (!configured) return DEFAULT_CONTROL_PLANE_DOMAINS;

  return configured
    .split(',')
    .map(domain => domain.trim().toLowerCase())
    .filter(Boolean);
};

export const isControlPlaneHost = (host = window.location.hostname): boolean => {
  const normalizedHost = host.trim().toLowerCase().replace(/^www\./, '');
  return configuredControlPlaneDomains().includes(normalizedHost);
};

export const getAdministrativeLoginPath = (): string =>
  isControlPlaneHost() ? '/login' : '/admin/login';
